import { Box, Container, Stack, Typography, Grid } from "@mui/material";
import React from "react";
import "./index.css";
// import CustomButton from "../generic-components/Button/Button";
// import AdsClickIcon from "@mui/icons-material/AdsClick";

const successStoryData = [
  {
    numberOfProjects: "15000+",
    projectHeading: "Successful Clients",
    projectDescription:"We have proudly served over 15,000 happy clients nationwide by providing reliable tax, bookkeeping, and business advisory services, and we look forward to helping even more clients achieve financial success.",
    projectImage: "/assets/success2.webp",
  },
  {
    numberOfProjects: "15+",
    projectHeading: "Tax Consultants",
    projectDescription: "Our expert team of tax professionals and BAS agents deliver personalized financial services tailored to individual and business needs, ensuring accuracy, compliance, strategic insight, and long-term financial stability nationwide.",
    projectImage: "/assets/success1.webp",
  },
  {
    numberOfProjects: "100%",
    projectHeading: "Lodgment Accuracy",
    projectDescription: "Our meticulous tax specialists ensure highly accurate lodgments and fully compliant reporting for individuals and businesses nationwide, regulatory adherence, and dependable financial outcomes across Australia.",
    projectImage: "/assets/success3.webp",
  },
];

function SuccessStory() {
  return (
    <>
      <div className="story-bg-image">
        <Container maxWidth="xl" sx={{ py: 6 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: 2,
            }}
          >
            <Typography className="success-story-title">
              Our Tax Expertise, Proven by Numbers
            </Typography>
            <Typography className="success-story-description">
              With over a decade of experience in Australian tax and bookkeeping services,
              Aspire Tax and Bookkeeping has helped individuals, sole traders, and businesses navigate 
              complex tax regulations. Our certified professionals are 
              committed to maximizing your tax returns, ensuring full compliance
              with ATO requirements, and supporting your long-term financial success.
            </Typography>
            {/* <CustomButton
              text="OUR MISSION & VISION"
              className="success-story-btn"
              endIcon={<AdsClickIcon />}
            /> */}
          </Box>

          <Grid
            container
            columns={12}
            columnSpacing={{ xs: 0, sm: 4 }}

            justifyContent="center"
            sx={{ mt: { xs: 0, sm: 0 } }}
          >
            {successStoryData.map((story, index) => (
              <Grid
                key={index}
                sx={{ gridColumn: "span 12", sm: "span 6", md: "span 4" }}
              >
                <Box>
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ mt: { xs: 4 } }}
                  >
                    <Box className="success-story-card">
                      <Stack
                        direction="row"
                        justifyContent="space-around"
                        alignItems="center"
                        sx={{ py: 4, paddingBottom: 0 }}
                      >
                        <img src={story.projectImage} alt="Success Story" className="card--images" />
                        <Box>
                          <Typography className="success-count">
                            {story.numberOfProjects}
                          </Typography>
                          <Typography className="success-heading">
                            {story.projectHeading}
                          </Typography>
                        </Box>
                      </Stack>
                      <Stack
                        direction="row"
                        justifyContent="space-around"
                        sx={{
                          padding: 2,
                          marginTop: 3,
                          marginBottom: 3,
                        }}
                      >
                        <Box>
                          <Typography className="success-description">
                            {story.projectDescription}
                          </Typography>
                        </Box>
                      </Stack>
                    </Box>
                  </Stack>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>
    </>
  );
}

export default SuccessStory;
